<template>
  <ui-modal-layout v-if="step === 1" :title="tr('Set up Google Authenticator')" :icon="QrCodeIcon">
    <!-- The description may carry markup (line breaks, the bolded secret). -->
    <p
      class="m-0 text-muted-foreground [&_strong]:font-semibold [&_strong]:break-all [&_strong]:text-foreground"
      v-html="description + tr('Set up your two factor authentication by scanning the barcode below with the Google Authenticator app. Alternatively, you can use the code :code', { ':code': '<strong>' + secret + '</strong>' })"
    />
    <!-- The QR code is an SVG rendered by the backend. -->
    <div v-if="qrCodeUrl" class="mx-auto w-52 rounded-xl bg-white p-3 [&_svg]:h-auto [&_svg]:w-full" v-html="qrCodeUrl" />
    <div v-else class="mx-auto flex size-52 items-center justify-center">
      <loader-circle-icon class="size-8 animate-spin text-primary" />
    </div>

    <template #footer>
      <ui-button variant="outline" @click="() => prev()">
        {{ tr('Back') }}
      </ui-button>
      <ui-button @click="() => next()">
        {{ tr('Next') }}
      </ui-button>
    </template>
  </ui-modal-layout>

  <google-2fa-code-form
    v-else-if="step === 2"
    v-model="code"
    :title="tr('Set up Google Authenticator')"
    :cancel-button-label="tr('Previous')"
    :is-loading="isSaving"
    @submit="() => confirm()"
    @cancel="() => prev()"
  />
</template>

<script>
import { LoaderCircle, QrCode } from '@lucide/vue';
import { markRaw } from 'vue';

import AuthService from '@/services/Auth';
import Google2faCodeForm from '@/ui/components/Google2faCodeForm.vue';

export default {
  name: 'EnableGoogle2fa',
  components: {
    Google2faCodeForm,
    LoaderCircleIcon: LoaderCircle,
  },
  props: {
    description: {
      type: String,
      required: false,
      default: () => '',
    },
  },
  data: () => ({
    QrCodeIcon: markRaw(QrCode),
    isLoading: false,
    isSaving: false,
    step: 1,

    secret: null,
    qrCodeUrl: null,
    code: '',
  }),
  created() {
    this.loadFristStep();
  },
  methods: {
    loadFristStep() {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;

      AuthService.enableGoogle2fa()
        .then(resp => {
          this.qrCodeUrl = resp.qr_url;
          this.secret = resp.secret;

          return resp;
        })
        .catch(err => {
          this.error(err);
          this.$emit('error', err);
          this.$emit('error-step-1');
        })
        .finally(() => this.isLoading = false);
    },
    prev() {
      if (this.step === 1) {
        this.$emit('cancel');
      }
      else {
        --this.step;
      }
    },
    next() {
      ++this.step;
    },
    confirm() {
      this.isSaving = true;

      AuthService.confirmEnableGoogle2fa(this.secret, this.code)
        .then(resp => {
          if (this.$root.loggedInUser) {
            this.$root.loggedInUser.google_2fa_enabled = true;
          }
          this.$toast.success(this.tr('Two-factor authentication has been successfully enabled.'));
          this.$emit('success');

          return resp;
        })
        .catch(err => this.error(err))
        .finally(() => this.isSaving = false);
    },
  },
};
</script>
